<!-- 组件说明 -->
<template>
  <div class="buy-ratio">
    <buy-ratio-item
      :toYear="toYear"
      type="sale"
      :statisticsData="statisticsData"
    />
    <buy-ratio-item
      :toYear="toYear"
      type="deal"
      :statisticsData="statisticsData"
    />
  </div>
</template>

<script>
import BuyRatioItem from "./BuyRatioItem";
export default {
  props: ["statisticsData", "toYear"],
  components: { BuyRatioItem },
  watch: {
    toYear(v) {
      this.toYear = v;
    },
  },
};
</script>

<style lang="scss" scoped>
.buy-ratio {
  display: flex;
  justify-content: space-between;
}
</style>
